import React from 'react';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';

import ControlPanel from 'ff/debrief/layouts/ControlPanel';
import LayerSelector from 'ff/debrief/components/map/LayerSelector';
import MapZoomControls from 'ff/debrief/components/map/MapZoomControls';
import SnapToRouteButton from 'ff/debrief/components/map/SnapToRouteButton';
import { AeroToggleButtons } from 'ff/debrief/components/map/settings/AeroToggleButtons';
import { useMapControls } from 'ff/debrief/hooks';
import HideSegmentDetailsButton from 'ff/debrief/components/map/HideSegmentDetailsButton';
import { isFeatureEnabled } from 'ff/common/ffAppUtils';

const MapControls = () => {
    const { aeroLayer } = useMapControls();
    return (
        <ControlPanel>
            <ButtonColumn>
                <UpperSection>
                    <UpperItem>
                        <LayerSelector />
                        {isFeatureEnabled('debrief_features') && (
                            <HideSegmentDetailsButton />
                        )}
                    </UpperItem>
                </UpperSection>
                <LowerSection spacing={1}>
                    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                    {(window as any).currentUser && aeroLayer && (
                        <AeroToggleButtons />
                    )}
                    <SnapToRouteButton />
                    <MapZoomControls />
                </LowerSection>
            </ButtonColumn>
        </ControlPanel>
    );
};

const UpperSection = styled(Stack)`
    flex-direction: row;
`;

const UpperItem = styled.div`
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const LowerSection = styled(Stack)``;

const ButtonColumn = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export default MapControls;
